import { api } from './client';
import type { ChannelDto, ChannelHealthDetail, ChannelLimits, ChannelUsageDto, ResolvedChannel } from './types';

export function listChannels(): Promise<ChannelDto[]> {
  return api.get<ChannelDto[]>('/api/v1/channels');
}

/** U5.1 — link / `@nickname` / numeric id -> name + avatar, before anything is saved. */
export function resolveChannel(query: string): Promise<ResolvedChannel> {
  return api.post<ResolvedChannel>('/api/v1/channels/resolve', { query });
}

export interface ChannelDetail extends ChannelDto {
  usage: ChannelUsageDto;
}

export function getChannel(id: string): Promise<ChannelDetail> {
  return api.get<ChannelDetail>(`/api/v1/channels/${id}`);
}

export interface DeleteChannelResult {
  deleted: boolean;
  dialogs: number;
  messages: number;
  jobs: number;
}

/** `force` cascades dialogs/messages (owner only); without it, open dialogs -> 409. */
export function deleteChannel(id: string, force = false): Promise<DeleteChannelResult> {
  return api.del<DeleteChannelResult>(`/api/v1/channels/${id}`, force ? { force: 'true' } : undefined);
}

export interface ConnectVkGroupBody {
  title: string;
  vk_group_id: number;
  token: string;
  callback_secret?: string;
}

export function connectVkGroup(body: ConnectVkGroupBody): Promise<ChannelDto> {
  return api.post<ChannelDto>('/api/v1/channels/vk-group', body);
}

export interface RegisterVkPersonalBody {
  vk_user_id: number;
  name: string;
  photo_url?: string | null;
  screen_name?: string | null;
}

export function registerVkPersonal(body: RegisterVkPersonalBody): Promise<ChannelDto> {
  return api.post<ChannelDto>('/api/v1/channels/vk-personal/register', body);
}

export interface PatchChannelBody {
  title?: string;
  limits?: Partial<ChannelLimits>;
}

export function patchChannel(id: string, body: PatchChannelBody): Promise<ChannelDto> {
  return api.patch<ChannelDto>(`/api/v1/channels/${id}`, body);
}

export function pauseChannel(id: string, reason: string): Promise<ChannelDto> {
  return api.post<ChannelDto>(`/api/v1/channels/${id}/pause`, { reason });
}

export function resumeChannel(id: string, reason: string): Promise<ChannelDto> {
  return api.post<ChannelDto>(`/api/v1/channels/${id}/resume`, { reason });
}

export function getChannelHealth(id: string): Promise<ChannelHealthDetail> {
  return api.get<ChannelHealthDetail>(`/api/v1/channels/${id}/health`);
}
